import {combineReducers} from 'external/react'
import UploadFile from 'components/Uploads/redux/reducer'

const rootReducer = combineReducers({UploadFile})

export default rootReducer
